/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const Title = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="1486.74px"
        height="542.3px"
        viewBox="0 0 1486.74 542.3"
        xmlSpace="preserve"
        className={className}
    >
        <g>
            <g>
                <defs>
                    <polygon
                        id="SVGID_1_"
                        points="0,542.3 1486.74,542.3 1486.74,257.71 0,356.05 			"
                    />
                </defs>
                <clipPath id="SVGID_2_">
                    <use xlinkHref="#SVGID_1_" style={{ overflow: 'visible' }} />
                </clipPath>
                <g clipPath="url(#SVGID_2_)">
                    <path
                        fill={color}
                        d="M100.26,516.99v-70.6c0-9.74-1.72-16.74-5.17-20.99c-3.44-4.25-8.61-6.38-15.5-6.38
    				c-7.42,0-12.8,2.17-16.16,6.51c-3.36,4.34-5.03,11.38-5.03,21.13v21.04H10.73v-26.35c0-15.59,3.84-28.78,11.52-39.59
    				c7.68-10.8,19.11-18.07,34.3-21.79v-64.91h47.68v64.91c14.3,3.72,25.17,10.81,32.58,21.26c7.42,10.46,11.13,24.01,11.13,40.66
    				v75.12H100.26z"
                    />
                    <path
                        fill={color}
                        d="M159.12,516.99c1.65-26.92,6.28-43.32,9.77-61.85c3.49-18.53,8.18-33.78,14.06-45.77
    				c5.88-11.98,12.96-21.34,21.23-28.07c8.27-6.73,17.92-11.57,28.95-14.52l-15.29-47.26h52.11l59.83,197.47h-51.56L244.7,403
    				c-7.17,1.66-13.28,6.46-18.33,14.38c-5.06,7.93-9.15,20.38-12.27,37.34c-3.13,16.97-7.48,33.5-8.95,62.27H159.12z M369.47,535.24
    				c-8.46,0-14.84-1.94-19.16-5.81c-4.32-3.87-7.49-8.02-9.51-12.45h-30.33V483.8h30.33c1.84-4.61,4.96-8.75,9.37-12.45
    				c4.41-3.68,10.84-5.53,19.3-5.53h10.2l-9.1,34.57l9.1,34.85H369.47z"
                    />
                    <path
                        fill={color}
                        d="M385.39,516.99l47.44-101.94h-35.37v-36.33c0-9.2-1.31-15.81-3.93-19.85c-2.62-4.03-6.08-6.57-10.39-7.6
    				c-4.3-1.03-8.89-1.55-13.75-1.55h-1.12c-3,7.14-6.79,12.49-11.37,16.05c-4.59,3.57-11.46,5.35-20.63,5.35h-7.58l13.75-55.19
    				h34.81c25.64,0,43.83,4.65,54.6,13.94c10.76,9.29,16.14,23.8,16.14,43.51v1.41h54.18l-64,142.21H385.39z"
                    />
                    <path
                        fill={color}
                        d="M738.74,516.99l47.05-107.39h-7.9c-18.53,0-32.21-4.17-41.05-12.51c-8.84-8.34-13.26-20.96-13.26-37.86
    				c0-4.86,0.36-9.71,1.1-14.57c0.74-4.86,1.63-9.93,2.69-15.21h-30.32v79.2c-10.53,8.87-22.26,16.05-35.21,21.54
    				c-12.95,5.49-26.69,8.24-41.21,8.24c-21.27,0-38.16-5.6-50.69-16.79c-12.53-11.19-18.79-27.45-18.79-48.79
    				c0-25.55,8.05-45.62,24.16-60.19c16.11-14.57,38.37-21.86,66.79-21.86H800c21.26,0,36.84,4.28,46.74,12.83
    				c9.89,8.55,14.84,20.65,14.84,36.27c0,7.4-1.53,15.52-4.58,24.39c-3.05,8.87-6.9,18.8-11.53,29.78l-53.37,122.92H738.74z
    				 M625.36,397.55c4.21,0,7.94-0.58,11.21-1.74c3.26-1.16,6.26-2.58,9-4.28v-62.09h-4.42c-12.21,0-21.69,3.38-28.42,10.14
    				c-6.74,6.76-10.11,17-10.11,30.73c0,9.72,2.16,16.69,6.47,20.91C613.41,395.45,618.84,397.55,625.36,397.55z M797.16,370.63h5.37
    				l2.21-5.07c1.68-4.22,3.05-8.18,4.11-11.88c1.05-3.69,1.58-7.13,1.58-10.3c0-4.22-1.42-7.6-4.26-10.14
    				c-2.84-2.53-7-3.8-12.48-3.8h-15.79c-1.47,4.23-2.48,8.13-3,11.72c-0.53,3.59-0.79,7.08-0.79,10.45c0,6.76,1.89,11.62,5.68,14.57
    				C783.58,369.15,789.37,370.63,797.16,370.63z"
                    />
                    <path
                        fill={color}
                        d="M929.54,381.67c-21.29,0-37.04-4.63-47.25-13.89c-10.21-9.26-15.31-21.08-15.31-35.46
    				c0-14.16,5.1-25.82,15.31-34.97c10.21-9.15,25.96-13.73,47.25-13.73h1.3h40.4c29.32,0,52.62,4.14,69.89,12.42
    				c17.27,8.28,29.6,20.92,36.98,37.92c7.38,17,11.08,38.57,11.08,64.72v118.32h-53.11V411.74c0-23.09-1.36-41.29-4.07-54.58
    				c-2.72-13.29-7.44-22.99-14.17-29.09c-6.74-6.1-16.18-9.81-28.35-11.11c1.52,4.58,2.28,9.59,2.28,15.04
    				c0,13.95-5.16,25.71-15.48,35.3C965.98,376.88,950.39,381.67,929.54,381.67z M929.54,351.92c5.64,0,10.21-1.69,13.68-5.07
    				c3.47-3.38,5.21-8.12,5.21-14.22c0-6.1-1.69-10.84-5.05-14.22c-3.37-3.38-7.98-5.07-13.85-5.07c-6.08,0-10.81,1.69-14.17,5.07
    				c-3.37,3.38-5.05,8.12-5.05,14.22c0,6.1,1.74,10.84,5.22,14.22C919,350.24,923.68,351.92,929.54,351.92z"
                    />
                    <path
                        fill={color}
                        d="M1197.26,516.99V398.39c-15.67-2.92-27.6-9.32-35.77-19.2c-8.18-9.88-12.26-23.47-12.26-40.77V311.5h-22.5
    				c-2.69,5.84-6.61,11.07-11.75,15.67c-5.15,4.61-12.43,6.91-21.83,6.91h-11.75l9.74-41.1l-9.74-40.77h11.75
    				c9.41,0,16.74,2.25,22,6.74c5.26,4.5,9.12,9.66,11.59,15.5h93.03c2.46-5.84,6.32-11,11.59-15.5c5.26-4.49,12.7-6.74,22.33-6.74
    				h11.42l-9.74,40.77l9.74,41.1h-11.42c-9.63,0-17.02-2.3-22.17-6.91c-5.15-4.6-9.07-9.82-11.75-15.67h-18.14v16.82
    				c0,12.58,2.69,21.51,8.06,26.79c5.37,5.28,14.44,7.92,27.2,7.92H1252v153.97H1197.26z"
                    />
                    <path
                        fill={color}
                        d="M1345.36,516.99V397.63h-35.97c-4.15,10.18-9.4,17-15.74,20.47c-6.34,3.47-13.09,5.2-20.23,5.2h-10.72
    				l14.87-63.84h67.79v-21.51c-16.14-3-28.42-9.65-36.83-19.95c-8.42-10.29-12.63-24.23-12.63-41.81v-38.51h53.61v28.11
    				c0,12.96,2.77,22.15,8.3,27.58c5.53,5.44,14.98,8.15,28.36,8.15h15.57v57.94h62.6l14.87,63.84h-10.72
    				c-7.15,0-13.89-1.73-20.24-5.2c-6.34-3.47-11.59-10.29-15.74-20.47h-30.78v119.36H1345.36z"
                    />
                </g>
            </g>
            <g>
                <defs>
                    <polygon id="SVGID_3_" points="1486.74,0 0,0 0,323.65 1486.74,225.3 			" />
                </defs>
                <clipPath id="SVGID_4_">
                    <use xlinkHref="#SVGID_3_" style={{ overflow: 'visible' }} />
                </clipPath>
                <g clipPath="url(#SVGID_4_)">
                    <path
                        fill={color}
                        d="M10.9,7.82h110.22v46.32H59.36v84.06h61.76v48.46H59.36v140.24H10.9V7.82z"
                    />
                    <path fill={color} d="M179.23,326.91h-48.46V7.82h48.46V326.91z" />
                    <path
                        fill={color}
                        d="M235.37,7.82l41.6,171.12V7.82h44.17v319.08h-39.46l-46.32-183.56v183.56h-43.75V7.82H235.37z"
                    />
                    <path fill={color} d="M523.69,326.91h-48.46V7.82h48.46V326.91z" />
                    <path
                        fill={color}
                        d="M579.83,7.82l41.6,171.12V7.82h44.17v319.08h-39.46l-46.32-183.56v183.56h-43.75V7.82H579.83z"
                    />
                    <path
                        fill={color}
                        d="M1083.82,266.87h-35.6l-6,60.04h-43.32l39.03-319.08h57.47l41.6,319.08h-46.75L1083.82,266.87z
    				 M1053.58,217.26h24.89l-12.66-115.94L1053.58,217.26z"
                    />
                    <path fill={color} d="M1192.41,7.82v209.65h59.18v51.32h-107.65V7.82H1192.41z" />
                    <path fill={color} d="M1309.75,7.82v209.65h59.18v51.32h-107.65V7.82H1309.75z" />
                    <path
                        fill={color}
                        d="M1435.6,194.38v132.52h-48.46V193.96L1343.4,7.82h47.18l22.3,119.23l21.44-119.23h43.75L1435.6,194.38z"
                    />
                    <path
                        fill={color}
                        d="M408.37,7.82h-74.19v319.08h74.19c39.89,0,54.47-24.02,54.47-63.47V69.15
    				C462.84,31.41,449.97,7.82,408.37,7.82z M413.09,76.02v179.7v24.92h-30.6V51.45h0.15v-0.31h13.72c1.5,0,2.89,0.1,4.17,0.31h12.56
    				V76.02z"
                    />
                    <path
                        fill={color}
                        d="M739.28,133.06v48.89h21.87v40.52v39.25v21.54h-34v-60.79h0.12V109.04h-0.12V51.12h30.53V70.5
    				c0.03,0.81,0.04,1.65,0.04,2.52v36.03h47.18V76.45c0-37.74-6-71.62-57.9-71.62h-9.43c-46.32,0-59.61,33.02-59.61,68.62v199.43
    				c0,33.02,17.58,58.33,46.32,58.33h3c24.45,0,40.74-24.87,44.17-35.6c3.86,13.72,7.72,29.59,8.15,31.31h27.45V133.06H739.28z"
                    />
                    <path
                        fill={color}
                        d="M967.86,164.79l-30.88-39.89c-16.3-21.02-19.73-30.88-19.73-48.89V71.6h-0.15V47.46h28.4V71.6h-0.37v40.87
    				h46.75V60.15c0-37.74-15.44-55.33-55.33-55.33h-9.01c-38.17,0-59.61,19.3-59.61,62.19V77.3c0,31.74,6,52.32,26.59,78.91
    				l30.88,39.46c17.58,23.16,19.73,30.45,19.73,53.61v7.29c0,0.24,0,0.47,0,0.71h0.05v27.06h-31.83v-27.06h0.05v-51.32h-48.03v63.9
    				c0,39.46,20.16,60.47,59.18,60.47h9.44c42.89,0,62.62-27.88,62.62-74.62v-10.29C996.6,208.97,989.73,193.1,967.86,164.79z"
                    />
                </g>
            </g>
        </g>
    </svg>
);

Title.propTypes = propTypes;
Title.defaultProps = defaultProps;

export default Title;
